import { useEffect, useRef, useState } from "react";
import { FaCheck, FaCopy, FaSpinner, FaTimes } from "react-icons/fa";

export default function QuestionUuidCopyButton({ value, label, buttonAs: Button = "button", onResult }) {
  const [phase, setPhase] = useState("idle");
  const request = useRef(0);
  const pending = useRef(false);
  const timer = useRef(null);
  useEffect(() => {
    setPhase("idle"); pending.current = false;
    return () => { request.current += 1; clearTimeout(timer.current); };
  }, [value]);
  const copy = async (event) => {
    event.stopPropagation();
    if (!value || pending.current) return;
    clearTimeout(timer.current);
    const token = ++request.current;
    pending.current = true; setPhase("pending");
    let success = false;
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(value);
      else {
        const previous = document.activeElement;
        const input = document.createElement("textarea");
        input.value = value; input.readOnly = true;
        input.style.cssText = "position:fixed;opacity:0;pointer-events:none";
        document.body.appendChild(input);
        try { input.select(); if (!document.execCommand?.("copy")) throw new Error("Copy failed"); }
        finally { input.remove(); if (previous?.isConnected) previous.focus(); }
      }
      success = true;
    } catch { /* Keep failure feedback beside the UUID that was clicked. */ }
    if (request.current !== token) return;
    pending.current = false;
    setPhase(success ? "copied" : "error");
    onResult?.(success);
    timer.current = setTimeout(() => { if (request.current === token) setPhase("idle"); }, 2000);
  };
  const feedback = { pending: "複製中…", copied: "已複製", error: "複製失敗，請重試" }[phase];
  const Icon = { pending: FaSpinner, copied: FaCheck, error: FaTimes }[phase] || FaCopy;
  return <Button type="button" title={feedback || "複製題目 UUID"} aria-label={`複製題目 UUID ${value}`}
    data-copy-state={phase} aria-busy={phase === "pending"} disabled={!value || phase === "pending"}
    onClick={copy} onDoubleClick={(event) => event.stopPropagation()}>
    <Icon aria-hidden="true" />
    {feedback ? <span role={phase === "error" ? "alert" : "status"} style={!label ? {
      position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap",
    } : undefined}>{feedback}</span> : label ? <span title={value}>{label}</span> : null}
  </Button>;
}
